// extracted by mini-css-extract-plugin
export default {"Hero":"Hero_Hero__BMW-2","HeroText":"Hero_HeroText__zxHYH","HeroTextInfo":"Hero_HeroTextInfo__eUL0g"};